import { MapContainer, TileLayer, Marker, Polyline, Popup } from 'react-leaflet';
import React, { useMemo, useEffect, useRef } from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

const ICON_URLS = {
  BOAT: '/images/boat.png',
  TRAIN: '/images/train.png',
  AIRPORT: '/images/airport.png',
  PLANE: '/images/airplane.png',
  DELIVERED: '/images/delivered.png',
  FACTORY: '/images/factory.png',
  PORT: '/images/port.png',
  RAILYARD: '/images/rail-yard.png',
  TRUCK: '/images/truck.png',
  WAREHOUSE: '/images/warehouse.png',
  MARKER: '/images/marker.png'
};

const makeIcon = (url) =>
  new L.Icon({
    iconUrl: url,
    iconSize: [50, 50],
    iconAnchor: [25, 25],
    popupAnchor: [0, -25],
  });

const getIcon = (mode) => makeIcon(ICON_URLS[mode] ?? ICON_URLS.MARKER);

const Map = ({coordinates}) => {
  const mapRef = useRef(null);

  useEffect(() => {
    if (mapRef.current) {
      if (coordinates.length === 1) {
        mapRef.current.setView([coordinates[0].LATITUDE, coordinates[0].LONGITUDE], 10);
      }
      else {
        const lastCoordinate = coordinates[coordinates.length - 1];
        mapRef.current.setView([lastCoordinate.LATITUDE, lastCoordinate.LONGITUDE], 5);
      }
    }
  }, [coordinates[0].LATITUDE, coordinates[0].LONGITUDE]);

  return (
    <MapContainer 
      ref={mapRef}
      center={[coordinates[0].LATITUDE, coordinates[0].LONGITUDE]} 
      zoom={10} 
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="Map data &copy; <a href='https://www.openstreetmap.org/'>OpenStreetMap</a> contributors"
      />

      {coordinates.map((coordinate, index) => (
        <Marker 
          position={[coordinate.LATITUDE, coordinate.LONGITUDE]}
          icon={getIcon(coordinate['TRAVEL MODE'])}
          key={index}>
          <Popup>{coordinate.DATE}</Popup>
        </Marker>
      ))}
      <Polyline positions={coordinates.map(coordinate => [coordinate.LATITUDE, coordinate.LONGITUDE])}/>
    </MapContainer>
  );
};

export default Map;
